import { default as NonProductionDaysHome } from "./Home";
import { default as NonProductionDaysCalendar } from "./Calendar";

export default { NonProductionDaysCalendar, NonProductionDaysHome };